<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <div class="col d-column">
      <h1
        class="title pt-2 mb-0"
        v-text="$ml.get('defaultMessageCenterMenu')"
      ></h1>
      <h1 class="title">
        <span class="pb-2" v-text="$ml.get('customSettingsSubtitle')"></span>
      </h1>

      <div class="card mb-3">
        <div class="card-header">
          <h6
            v-text="$ml.get('registeredMessageTitle')"
            class="m-0 p-0 light"
          ></h6>
          
        </div>
        <div v-if="messages.length !== 11" class="card-body p-0">
          <b-button
            class="m-3 d-flex justify-content-center"
            size="sm"
            v-b-modal.modal-1
          >
            <span v-text="$ml.get('addMessageButton')"></span>
          </b-button>
        </div>
        <div v-show="messages.length===11" class="card-body p-16">
          <div class="box-alert">
            <svg width="16" height="16">
              <image
                xlink:href="../../../src/assets/icons/alert_limit.svg"
                width="16"
                height="16"
              />
            </svg>
            <h6 class="title-info">
              <span class="attention-alert">{{ $ml.get("attention") }}</span
              > {{ $ml.get("existingMessageAlert") }}
            </h6>
          </div>
        </div>
        
        <div v-if="messages.length > 0" class="card-body p-0">
          <div v-for="message in messages" :key="message._id" class="form-group">
            <div
              v-b-toggle="message._id"
              @click="message.collapsed = !message.collapsed"
              class="box-list d-flex justify-content-between align-items-start px-3"
            >
              <div class="d-flex align-items-end">
                <h5 class="title-card-message m-0 mr-2">
                  {{ message.title }} <br />
                  <span class="type_message"
                    >{{ $ml.get("type") }}: {{ $ml.get(message.type) }}</span
                  >
                </h5>
                <svg width="10" height="10" class="mb-1">
                  <image
                    v-if="!message.collapsed"
                    xlink:href="../../assets/icons/icon-down.svg"
                    width="10"
                    height="10"
                  />
                  <image
                    v-else
                    xlink:href="../../assets/icons/icon-up.svg"
                    width="10"
                    height="10"
                  />
                </svg>
              </div>
              <div class="d-flex mb-3">
                <svg
                  width="16"
                  height="16"
                  class="mr-2"
                  @click="
                    showModalEdit(
                      message._id,
                      message.title,
                      message.message,
                      message.is_automatic,
                      message.type,
                    )
                  "
                  v-b-modal.modal-edit
                >
                  <image
                    xlink:href="../../assets/icons/edit.png"
                    width="16"
                    height="16"
                  />
                </svg>
                <svg @click="deleteMessage(message._id)" width="16" height="16">
                  <image
                    xlink:href="../../assets/icons/trash-alt.svg"
                    width="16"
                    height="16"
                  />
                </svg>
              </div>
            </div>
            <b-collapse :visible="false" :id="message._id">
              <b-card class="mt-2">
                <p class="message-description">
                  <span v-if="!message.show_full_description">
                    {{ message.message.substring(0, 150) }}
                    <a
                      v-if="message.message?.length > 150"
                      class="detailsMessage"
                      @click="message.show_full_description = true"
                      >ver mais...</a
                    >
                  </span>
                  <span v-else>
                    {{ message.message }}
                    <a
                      class="detailsMessage"
                      @click="message.show_full_description = false"
                      >ver menos...</a
                    >
                  </span>
                </p>
              </b-card>
            </b-collapse>
          </div>
        </div>
        <div class="card-body d-flex justify-content-center align-items-center" v-else>
          <h6 v-text="$ml.get('registerNotFound')"></h6>
        </div>
        <ModalRegisterMessage
          @update-data="fetchData()"
          :message_type="message_types_props"
        />
        <ModalEditMessage
          @update-data="fetchData()"
          :idMessage="idMessage"
          :title="title_props"
          :message="message_props"
          :is_automatic="is_automatic_props"
          :type="type_props"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import CompanyService from "../../services/company.service";
import ModalEditMessage from "../company/program/modalEditMessage.vue";
import ModalRegisterMessage from "../company/program/modalRegisterMessage.vue";
export default {
  components: {
    ModalRegisterMessage,
    ModalEditMessage,
  },
  data() {
    return {
      idMessage: "",
      messages: [],

      title_props: "",
      message_props: "",
      is_automatic_props: false,
      type_props: "",

      message_types_props: [],
    };
  },

  methods: {
    mergeObject(data) {
      return data.map((message) => {
        return {
          ...message,
          show_full_description: false,
          collapsed: false,
        };
      });
    },

    async fetchData() {
      try {
        const { data } = await CompanyService.getMessageDefault();
        this.messages = data ? this.mergeObject(data) : [];
        this.message_types_props = data.map((message) => message.type);
      } catch (error) {
        console.log(error);
      }
    },

    deleteMessage(id) {
      Swal.fire({
        title: this.$ml.get("deleteMessageAlert"),
        type: "info",
        showCancelButton: true,
        confirmButtonText: this.$ml.get("remove"),
        cancelButtonText: this.$ml.get("cancel"),
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn",
          cancelButton:
            "btn float-right btn-outline-extra btn-primary btn-sm btn-cancel",
        },
      }).then((result) => {
        if (result.value) {
          CompanyService.deleteMessageDefault(id).then(
            () => {
              Swal.fire({
                icon: "success",
                title: this.$ml.get("alertMessageRemoved"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              this.fetchData();
            },
            (error) => {
              if (error.response.status == 403) {
                Swal.fire({
                  icon: "info",
                  title: this.$ml.get("unableToCompleteThisRequest"),
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
            },
          );
        }
      });
    },

    showModalEdit(id, title, message, is_automatic, type) {
      this.idMessage = id;
      this.title_props = title;
      this.message_props = message;
      this.is_automatic_props = is_automatic;
      this.type_props = type;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
<style lang="scss">
.inputTags {
  box-shadow: none !important;
  background-color: white;
  input {
    background: rgb(255, 255, 255);
    border-radius: 0;
    box-shadow: none !important;
  }
  .badge-primary {
    color: #8a0ba9;
    background: #cccccc00;
    padding: 3px 4px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid #8a0ba9;
    margin-right: 10px;
    margin-top: 10px;
    border-radius: 5px;
  }
  .btn {
    display: none;
  }
}
.boxMessage {
  box-shadow: 0px 0px 4px 1px #6c757d21;
  padding: 10px;
  margin-bottom: 10px;
}
.detailsMessage {
  cursor: pointer;
  font-weight: 400;
}
.title-menssage {
  font-family: "Poligon";
  font-size: 1.2rem;
  padding: 10px;
}
.title-box-message {
  font-size: 1.1rem;
}

.box-list {
  border-bottom: 1px solid #740ca813;
}
.title-message {
  font-size: 1.3em;
  font-weight: 400;
}
.title-card-message {
  font-family: "Poligon";
  font-weight: 500;
  font-style: normal;
  font-size: 15.2px;
}
.message-description {
  color: #6c757d !important;
  font-size: 0.95rem;
  font-family: "Poligon", sans-serif;
}
.type_message {
  font-family: "Poligon";
  color: #6c757d;
  font-size: 0.8rem;
  line-height: 1.2;
  font-weight: 300;
}
.btn-confim {
  margin-right: 10px;
}
.btn-cancel {
  margin-left: 10px;
}
.box-alert {
  display: grid;
  grid-template-columns: 30px 1fr;
  align-items: center;
  background: #aaaaaa21;
  border-radius: 5px;
  padding: 16px;
}
.title-info {
  color: #6c757d !important;
  font-size: 0.87rem;
  font-family: "Poligon", sans-serif;
  max-width: 100%;
}
.attention-alert {
  font-weight: 500;
}
.box-message-empty {
  margin: 50px 5px 10px 5px;
  box-shadow: 0px 0px 4px 1px #aaaaaa3a;
  padding: 10px;
  text-align: center;
}
</style>
